import { createContext, useContext } from 'react';

export const AppHotelChainSlugContext = createContext<string | undefined>(undefined);

export const useHotelChainSlug = () => useContext(AppHotelChainSlugContext);

export type AppHotelChainSlugProviderProps = {
  hotelChainSlug?: string;
  children?: React.ReactNode;
};

export const AppHotelChainSlugProvider: React.FC<AppHotelChainSlugProviderProps> = ({
  hotelChainSlug,
  children,
}) => {
  return (
    <AppHotelChainSlugContext.Provider value={hotelChainSlug}>
      {children}
    </AppHotelChainSlugContext.Provider>
  );
};

export default AppHotelChainSlugProvider;
